import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { Slice } from '../kernel_names';
import { pad } from '../ops/pad';
import { parseSliceParams } from '../ops/slice_util';
export var sliceGradConfig = {
  kernelName: Slice,
  inputsToSave: ['x'],
  gradFunc: function gradFunc(dy, saved, attrs) {
    var _saved = _slicedToArray(saved, 1),
        x = _saved[0];

    var begin = attrs.begin,
        size = attrs.size;
    var inputShape = x.shape;

    var _parseSliceParams = parseSliceParams(x, begin, size),
        _parseSliceParams2 = _slicedToArray(_parseSliceParams, 2),
        begin_ = _parseSliceParams2[0],
        size_ = _parseSliceParams2[1]; // Create an Nx2 padding where the first column represents how many
    // zeros are prepended (at start) for each dimension, and the second
    // column indicates how many zeros are appended (at end).
    // The number of zeros to append is the shape of the input
    // elementwise-subtracted by both the begin vector and sizes vector.


    var paddings = [];

    for (var i = 0; i < dy.rank; i++) {
      paddings.push([begin_[i], inputShape[i] - begin_[i] - size_[i]]);
    }

    return {
      x: function x() {
        return pad(dy, paddings);
      }
    };
  }
};